import { render, staticRenderFns } from "./not-available.vue?vue&type=template&id=519f6e20&"
import script from "./not-available.vue?vue&type=script&lang=js&"
export * from "./not-available.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports